import { ReactNode } from 'react';

type Props = {
  stickyBottomRows?: ReactNode[];
};

const TanTableFooter = ({ stickyBottomRows = [] }: Props) => {
  return <tfoot>{stickyBottomRows.map((r) => r)}</tfoot>;
};

export default TanTableFooter;
